import { PriceDisplayStatus } from '../getPriceDisplayStatus/getPriceDisplayStatus';

const PRICE_DISPLAY_TRANSLATION_KEYS: Record<PriceDisplayStatus, string> = {
    fees: 'gig_page_perseus.packages.plus_fees',
    taxes: 'gig_page_perseus.packages.plus_taxes',
    both: 'gig_page_perseus.packages.plus_taxes_and_fees',
    none: '',
};

export const getPriceDisplayTranslationKey = (status: PriceDisplayStatus): string =>
    PRICE_DISPLAY_TRANSLATION_KEYS[status];
